<div class="dialog-header">
    <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    <div class="title">{{ 'viewAccessPointCodeDialog.title' | translate }}</div>
    <div class="content">
        <p>{{ 'viewAccessPointCodeDialog.accessCodeTitle' | translate }}</p>
        <p class="access-point-code">{{ data?.accessPointCode }}</p>
        <p>{{ 'viewAccessPointCodeDialog.confidentialNote' | translate }}</p>
    </div>
</div>
